import { deleteTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteTenderCallable = getCallable(deleteTenderDefinition);
